import { render, staticRenderFns } from "./IMC.vue?vue&type=template&id=61551dd8&scoped=true&"
import script from "./IMC.vue?vue&type=script&lang=js&"
export * from "./IMC.vue?vue&type=script&lang=js&"
import style0 from "./IMC.vue?vue&type=style&index=0&id=61551dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61551dd8",
  null
  
)

export default component.exports